import React from 'react'
import { Notification } from 'is24-corecss'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '../../../../../../../app/hooks'
import { InitState } from '../../../../../../../redux/reducers/root/initialState'

type FairPriceNotificationProps = {
  minValue: number
  maxValue: number
}

export function FairPriceNotification({ minValue, maxValue }: FairPriceNotificationProps) {
  const { t, i18n } = useTranslation()
  const { rentControlApplies, city } = useAppSelector((state: InitState) => state.rentControlFeature)
  const rentControlDisclaimer =
    city && rentControlApplies === true
      ? ` ${t('wizard.screen.basicInfo.price.recommendedNotification.rentControlDisclaimer', { city })}`
      : city && rentControlApplies === false
        ? ` ${t('wizard.screen.basicInfo.price.recommendedNotification.rentControlNotApplicableDisclaimer', { city })}`
        : ''

  return (
    <Notification
      type='success'
      size='medium'
      variant='flat'
      title=''
      message={
        t('wizard.screen.basicInfo.price.recommendedNotification.success', {
          minValue: minValue.toLocaleString(i18n.language),
          maxValue: maxValue.toLocaleString(i18n.language),
        }) + rentControlDisclaimer
      }
    />
  )
}
